import { useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { usePlatform } from '../context/PlatformContext';
import { useAuth } from '../context/AuthContext';

export function EarlyAccessBanner() {
  const { ordersEnabled, loading } = usePlatform();
  const { testMode } = useAuth();
  const location = useLocation();

  if (loading || ordersEnabled || location.pathname === '/') return null;

  // Stack below the test-mode banner when both are visible (mirrors TestModeBanner pattern)
  const topOffset = testMode?.active ? 'top-10' : 'top-0';

  return (
    <div
      className={`fixed ${topOffset} left-0 right-0 z-[60] h-10 bg-[#CDDC39] text-black text-xs sm:text-sm font-semibold px-4 flex items-center justify-center gap-2`}
      data-testid="early-access-banner"
    >
      <Sparkles className="w-4 h-4 shrink-0" />
      <span>Early Access... You will be notified when Tune4Tune launches</span>
    </div>
  );
}
